import { useEffect, useState } from "react";
import {
  Button,
  Grid,
  TextField,
  Typography,
  ButtonGroup,
} from "@mui/material";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';

import GetEquipmentInfoActual, {
  EquipmentAndRecommendation,GetEquipmentPlanogramInfoActual
} from "../utils/GetEquipmentInfoAll";
import { TextFieldData } from "../componentUtils/TextFields";
// import VendingVisualizer from "./VendingVisualizer";
import { useLocalStorage } from "../utils/LocalStorageHook";
// import MaterialsComponent from "./MaterialComponent";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";
import PageInPage from "../componentUtils/PageInPage";
import RecommendationComponent from "./request/Recommend";
import { useHistory } from "react-router-dom";
import VendPrimeRequest from "../pages/VendPrime/VendPrimeRequest";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { getRequests } from "src/utils/GetRequest";
import VendingVisualizer from "./VendingVisualizer";
import MaterialsComponent from "./MaterialComponent";

interface EquipmentInfoPageInput {
  customerData: any;
  equipmentNum: string;
  customerNum: string;
  status: any;
}

interface EquipmentInfoState {
  isLoaded: boolean;
  data: EquipmentAndRecommendation | undefined;
  requests: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    mapContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textName: {
      paddingTop: theme.spacing(2),
    },
    undo: {
      width: 18,
      height: 18,
    },
  })
);

export default function EquipmentUnitIndiv(props: EquipmentInfoPageInput) {
  const classes = useStyles();
  const history = useHistory();
  const [state, setState] = useState<EquipmentInfoState>({
    isLoaded: false,
    data: undefined,
    requests: undefined,
  });
  const [orderState, setOrderState] = useState<any>({
    name: "material_num",
    direction: "asc",
  });
  const [open, setOpen] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>();
  const [toReplace] = useState<any[]>([]);
  const [replacePtr] = useState<number>(0);
  const [replaced] = useState<any[]>([]);
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [showRec] = useState<boolean>(false);
  const [newFlavors] = useState<boolean>(true);
  const [maxFlavors] = useState<boolean>(false);
  const [displayPip, setDisplayPip] = useState<boolean>(false);
  const disabledTextFields: TextFieldData[] = [
    {
      title: "Equipment ID",
      field: "equipment_num",
      md: 3,
      lg: 2,
    },
    {
      title: "Asset Number",
      field: "asset_num",
      md: 3,
      lg: 2,
    },
    // {
    //   title: "Manufacturer",
    //   field: "manufacturer",
    //   md: 6,
    //   lg: 4,
    // },
    {
      title: "Model",
      field: "model",
      md: 4,
      lg: 2,
    },
    {
      title: "Delivery Plant",
      field: "delivering_plant",
      md: 4,
      lg: 2,
    },
    // {
    //   title: "Serial Number",
    //   field: "serial_num",
    //   md: 4,
    //   lg: 4,
    // },
    // {
    //   title: "Settlement Method",
    //   field: "settlement_method",
    //   md: 6,
    //   lg: 2,
    // },
  ];
  const disabledTextFieldsTelemeter: TextFieldData[] = [
    {
      title: "Telemeter Manufacturer",
      field: "manufacturer",
      md: 4,
      lg: 2,
    },
    {
      title: "Telemeter Model",
      field: "model",
      md: 4,
      lg: 2,
    },
    {
      title: "Telemeter Serial Number",
      field: "subSerialNum",
      md: 4,
      lg: 2,
    },
    {
      title: "DEX Device ID",
      field: "dexDeviceId",
      md: 4,
      lg: 2,
    },
  ];

  const filterOutOldReq = (r: any) => {
    let now = new Date();
    if (
      [
        "VP_DRAFT",
        "VP_QUEUE",
        "VP_REQUST",
        "VP_ACCEPT",
        "VP_SUBMIT",
        "I",
        "O",
      ].findIndex((s) => s === r.requestStatus) >= 0
    ) {
      return true;
    } else if (
      ["VP_AS_IS", "Y", "S", "M"].findIndex(
        (s) => s === r.requestStatus
      ) >= 0
    ) {
      let days_back = Math.ceil(
        Math.abs(
          new Date(Date.parse(r.requestedDt)).getTime() - now.getTime()
        ) /
          (1000 * 3600 * 24)
      );
      if (days_back <= 30) {
        return true;
      }
    }
    return false;
  };
 
  const makeTwoRequests = async () => {
    let eq = await GetEquipmentPlanogramInfoActual(
      salesOrg.toString(),
      props.customerNum,
      newFlavors,
      maxFlavors,
      false,
      false
    );

    let req = await getRequests(salesOrg.toString(), {
      customerNum: props.customerNum,
    }).catch((err: any) => null);

    req.requests = req.requests.filter((r: any) => filterOutOldReq(r));

    return { eq, req };
  };

  useEffect(() => { 
    if (state.data?.cmap) return;
    makeTwoRequests().then((v: any) => {
      
      setState({
        ...state,
        data: v.eq,
        isLoaded: true,
        requests: v.req || [],
      });
    });
  }, [state.isLoaded]);

if (state.data?.errorMessage) {
  return <div>{state.data.errorMessage}</div>;
}

if (!state.isLoaded || !state.data?.cmap) {
  return <div />;
}

  const location =
    state.data.info.building +
    " " +
    state.data.info.floor +
    " " +
    state.data.info.room;
  return (
    
    <div className={classes.root}>
      <Grid container spacing={2} className={classes.gridMarginTop}>
        {disabledTextFields.map((v: TextFieldData, i: number) => {
          let q = (state.data?.info as any)[v.field];
          return (
            <Grid
              item
              xs={v.md}
              md={v.lg}
              className={classes.gridSpaceable}
              key={`EquipmentUnitIndiv-disabledTextFields-${i}-grd`}
            >
              <TextField
                fullWidth={true}
                key={`EquipmentUnitIndiv-disabledTextFields-${i}`}
                label={v.title}
                value={q}
                defaultValue={q}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          );
        })}

        <Grid
          item
          xs={6}
          md={4}
          lg={2}
          className={classes.gridSpaceable}
          key={`EquipmentUnitIndiv-location-grd`}
        >
          <TextField
            fullWidth={true}
            key={`EquipmentUnitIndiv-location`}
            label="Location"
            value={location}
            defaultValue={location}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        {disabledTextFieldsTelemeter.map((v: TextFieldData, i: number) => {
          if ((state.data?.cmap.length || 0) > 0) {
            let q = (state.data?.cmap[0] as any)[v.field];
            if (q) {
              return (
                <Grid
                  item
                  xs={v.md}
                  md={v.lg}
                  className={classes.gridSpaceable}
                  key={`EquipmentUnitIndiv-disabledTextFieldsTelemeter-${i}-grd`}
                >
                  <TextField
                    fullWidth={true}
                    key={`EquipmentUnitIndiv-disabledTextFieldsTelemeter-${i}`}
                    label={v.title}
                    value={q}
                    defaultValue={q}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              );
            }
          }
        })}
      </Grid>
      <Grid
        container
        spacing={2}
        key={`EquipmentUnitIndiv-VendingVisualizer-grd`}
      >
        <Grid item sm={12} lg={6}>
          <ButtonGroup>
            {!state.requests.requests || state.requests.requests.length < 1 ? 
              (props.status === 'INIT' || props.status === 'DISP' ) ? <></>
              :
              (
              <Button
                color="primary"
                variant="contained"
                key={`EquipmentUnitIndiv-reconfigbutton1`}
                onClick={() => window.open("/vendprime/reconfig/" + state.data?.info?.customer_num)}
                // disabled={state.data.cmap[0].settlement_method !== 5}
                disabled={props.status === ''}
              >
                <ViewCompactIcon style={{ marginRight: "5px" }} />
                Optimize Space to Sales
              </Button>
            ) : (
              <Button
                color="primary"
                variant="contained"
                key={`EquipmentUnitIndiv-reconfigbutton2`}
                  onClick={() => setOpen(true)}
                hidden={
                  !state.requests.requests || state.requests.requests.length < 1
                }
              >
                <ConfirmationNumberIcon style={{ marginRight: "5px" }} />
                View Open Tickets
              </Button>
            )}
          </ButtonGroup>

          <Typography variant="h6" className={classes.textName}>
            Vending Visualizer
          </Typography>
          <VendingVisualizer
            onHover={(matnr: string) => {
              setSelected(matnr);
            }}
            updateLayout={() => {}}
            recommended={[]}
            // onClick={() => {}}
            replacing={toReplace}
            selected={selected}
            replaced={replaced}
            replacePtr={replacePtr}
            cols={state.data?.cols}
            columnmap={state.data?.columns}
            columns={state.data.cmap}
            salesOrg={salesOrg}
          />
        </Grid>
        <Grid
          item
          sm={12}
          lg={6}
          key={`EquipmentUnitIndiv-MaterialsComponent-grd`}
          sx={{mt:'6%'}}
        >
          <MaterialsComponent
            selected={selected}
            onHover={(matnr: string) => {
              setSelected(matnr);
            } }
            state={state}
            customer={props.customerNum}
            isActive={true}
            orderState={orderState}
            onOrderStateChange={(changedColumn: string, direction: string) => {
              setOrderState({
                name: changedColumn,
                direction: direction,
              });
            }}
            />
        </Grid>
      </Grid>
      <PageInPage
        onClose={() => {
          setOpen(false);
        }}
        title={`Reconfiguration for ${props.customerData.deliveringPlant}: ${props.customerNum} ${props.customerData.name1} [${location}]`}
        isOpen={open}
        content={
          <RecommendationComponent
            fullpage={false}
            customer={props.customerNum}
          />
        }
      />
      <PageInPage
        onClose={() => {
          setDisplayPip(false);
        }}
        title={`Testme`}
        isOpen={displayPip}
        content={
          <VendPrimeRequest
            requestNum={
              state.requests.requests && state.requests.requests.length > 0
                ? state.requests.requests[0].requestNum
                : 0
            }
            onClose={() => {
              setDisplayPip(false);
            }}
          />
        }
      />
    </div>
  );
}
